import { Box, Typography } from "@mui/material";

const AboutUs: React.FC = () => {
    return (
        <Box component="section" className="home-section" >
            <Typography variant="h4" align="center" sx={{ fontWeight: "bold", mb: 4, }} >
                About Us
            </Typography>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 4,
                    maxWidth: "1200px",
                    margin: "0 auto",
                }}
            >
                <Box
                    sx={{
                        flex: "1",
                        maxWidth: { md: "50%" },
                    }}
                >
                    <Typography
                        variant="body1"
                        sx={{
                            mb: 3,
                            fontSize: "1.2rem",
                            lineHeight: 1.8,
                            textAlign: "justify",

                        }}
                    >
                        We are a dedicated team focused on simplifying appointment and client management for businesses such as clinics, salons, and service providers. Our platform is designed to serve both organization managers and clients through a seamless, intuitive web experience.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        flex: "1",
                        maxWidth: { md: "50%" },
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "hidden",
                        borderRadius: "16px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",

                    }}
                >
                    <img
                        src="aboutUs.jpg"
                        alt="About Us"
                        style={{
                            width: "100%",
                            height: "auto",
                            maxHeight: "400px",
                            objectFit: "fill",
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default AboutUs;